import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Report from 'powerbi-report-component';

import { postData } from '../dataLib';

import { Button } from '@material-ui/core';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    //toolbar: theme.mixins.toolbar,;
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class IniArcades extends Component {


    constructor(props) {
        super(props);

        this.report =  null;

        this.state = {
            token: ''
        }
    }

    componentDidMount = () => {

        if (this.props.user && this.props.user.profile.sub === '795') {

            postData(
                'https://ilusiona-redemptionreports-prod.azurewebsites.net/api/PBI/CreateToken',
                (response) => {
                    this.setState({ ...this.state, token: response.data })
                },
                () => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'ERROR updating arqueo'
                    }, 'error-create-token', false, 'sm');
                },
                {
                    workspaceId: '776470de-5903-4f74-b7ea-6f7563f7932e',
                    reportId: 'e3c7772c-f353-44ec-8212-7b835eb92678'
                },
                this.props.user,
                true
            );
        }

    }

    handleReportLoad = (report) => {
        this.report = report; // get the report object from callback and store it.
    }

    handleReportRender = (report) => {
        this.report = report; // get the report object from callback and store it.
    }


    render() {

        const { classes } = this.props;

        const reportStyle = {
            height: 800
        };

        if (!this.props.user) {
            return (
                <div className={classes.root}>
                    <div className={classes.toolbar} />
                    <div>Please login</div>
                </div>
            );
        }
        else {
            return (

                <div className={classes.root}>
                    <div className={classes.toolbar} />
                    {this.state.token === '' ?
                        <div>Información/resumen para este usuario</div>
                        :
                        <div>
                            <Report
                                embedType="report"
                                tokenType="Embed"
                                accessToken={this.state.token}
                                embedUrl="https://app.powerbi.com/reportEmbed?reportId=e3c7772c-f353-44ec-8212-7b835eb92678&groupId=776470de-5903-4f74-b7ea-6f7563f7932e"
                                embedId="e3c7772c-f353-44ec-8212-7b835eb92678"
                                permissions="View"
                                style={reportStyle}
                                onLoad={this.handleReportLoad}
                                onRender={this.handleReportRender}
                            />
                            <Button variant="contained" color="secondary" className={classes.button} onClick={() => {
                                if (this.report) {
                                    this.report.fullscreen();
                                }
                            }}>
                                Pantalla completa
                            </Button>
                            <Button variant="contained" color="secondary" className={classes.button} onClick={() => {
                                if (this.report) {
                                    this.report.print();
                                }
                            }}>
                                Imprimir
                            </Button>
                        </div>
                    }
                </div>


            );
        }
    };

};

IniArcades.propTypes = {
    user: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(IniArcades));